import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRefundOrderMutation = createMutationHook(OrderApiClient.refundOrder, {
  mutationKey: ['refundOrder'],
})
